import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '@welldev-group/rcl-icon';

const EmptyTableContent = props => {
  const {
    iconSize,
    iconName,
    iconColor,
    emptyText,
    fullHeight,
    showIconBackGround,
  } = props;
  return (
    <div
      className={classNames('empty-table', {
        'empty-table--with-full-height': fullHeight,
      })}
    >
      <div className="empty-table__icon">
        <Icon
          name={iconName}
          showBGColor={showIconBackGround}
          color={iconColor}
          size={iconSize}
        />
      </div>
      <div className="empty-table__text">
        {emptyText || I18n.t('shared.no_result')}
      </div>
    </div>
  );
};

EmptyTableContent.defaultProps = {
  iconSize: 'medium',
  iconName: 'add',
  iconColor: 'tertiary',
  emptyText: null,
  fullHeight: false,
  showIconBackGround: true,
};

EmptyTableContent.propTypes = {
  iconSize: PropTypes.string,
  iconName: PropTypes.string,
  iconColor: PropTypes.string,
  emptyText: PropTypes.string,
  fullHeight: PropTypes.bool,
  showIconBackGround: PropTypes.bool,
};
export default EmptyTableContent;
